import { render, staticRenderFns } from "./divorceAgreement.vue?vue&type=template&id=8f9f6198&scoped=true&"
import script from "./divorceAgreement.vue?vue&type=script&lang=js&"
export * from "./divorceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./divorceAgreement.vue?vue&type=style&index=0&id=8f9f6198&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9f6198",
  null
  
)

export default component.exports